<template lang="pug">
  app-dialog(v-model="$_show" header="Выбрать специализацию" @confirm="addSpecialisation()" confirmText="Добавить")
    app-select(v-model="form.specialisationType" label="Специализация судьи" :items="specialisationTypes" item-text="title" return-object)
    div(v-show="form.specialisationType.name==='ADDRESS'" )
      app-text-field(v-model="form.address" label="Адрес") 
</template>

<script>
import { AppDialogToggable } from '@/components'
import { judgeService } from "@/_services";
import { mapState, mapGetters, mapMutations } from 'vuex'

let defaultForm = {
  specialisationType: '',
  address: '',
  id: ''
}

export default {
  mixins: [AppDialogToggable],
  computed: {
    ...mapState('judgeReestr', ['currentJudge']),
    ...mapGetters('judgeReestr', ['specialisationTypes']),
  },
  methods: {
    ...mapMutations('judgeReestr', ['setJudgeInJudges']),

    addSpecialisation () {
      let obj = {
        "address": this.form.address,
        "specialisationType": this.form.specialisationType,
        "judge": this.currentJudge
      }

      judgeService.updateSpecialization(obj).then(data => {
        this.currentJudge.judgeSpecialisation.push(data)
        this.updateJudge ()
      })
    },

    updateJudge () {
      this.currentJudge.signImage = ''
      judgeService.updateJudge(this.currentJudge).then(data => this.setJudgeInJudges(data))
      return true
    }
  },
  data () {
    return {
      form: defaultForm
    }
  },
}
</script>